import React, { forwardRef } from 'react';
import FormInput from './FormInput';

/**
 * DatePicker - Componente especializado de FormInput para fechas
 *
 * Props:
 * - label: Texto del label
 * - error: Mensaje de error (opcional)
 * - required: Indica si el campo es requerido (opcional)
 * - placeholder: Placeholder del input (default: "DD/MM/YYYY")
 * - className: Clases CSS adicionales (opcional)
 * - ...props: Cualquier otra prop de input HTML estándar
 */
const DatePicker = forwardRef(({
  label,
  error,
  required = false,
  placeholder = 'DD/MM/YYYY',
  className = '',
  ...props
}, ref) => {
  return (
    <FormInput
      ref={ref}
      label={label}
      error={error}
      required={required}
      type="date"
      placeholder={placeholder}
      className={`hide-date-icon ${className}`}
      {...props}
    />
  );
});

DatePicker.displayName = 'DatePicker';

export default DatePicker;
